import { useEffect, useState } from "react";

const WA_LINK_1 = "https://wa.link/rb4jxv";

export default function HeroSection() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* Navbar */}
      <nav
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
          scrolled ? "bg-black shadow-lg" : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
          <div className="flex items-center gap-3">
            <a
              href="https://www.youtube.com/watch?v=8Zsw4lYVfXc"
              target="_blank"
              rel="nofollow noreferrer"
              className="cursor-pointer"
            >
              <img
                src="https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/2fb0211a325efcbbe44a3ea0acbd81a4.png"
                alt="Repuestos Octavio Ospina Sanchez Logo"
                className="h-20 md:h-24 w-auto object-contain rounded-md ring-2 ring-white/20 shadow-lg"
              />
            </a>
            <span className="text-white font-black text-sm md:text-lg hidden sm:block leading-tight drop-shadow-md">
              Repuestos<br />
              <span className="text-[#E10600]">Octavio Ospina</span>
            </span>
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#empresa" className="text-white/80 hover:text-white text-sm font-medium transition-colors whitespace-nowrap">Nosotros</a>
            <a href="#categorias" className="text-white/80 hover:text-white text-sm font-medium transition-colors whitespace-nowrap">Repuestos</a>
            <a href="#vehiculos" className="text-white/80 hover:text-white text-sm font-medium transition-colors whitespace-nowrap">Vehículos</a>
            <a href="#contacto" className="text-white/80 hover:text-white text-sm font-medium transition-colors whitespace-nowrap">Contacto</a>
          </div>
          <a
            href={WA_LINK_1}
            target="_blank"
            rel="nofollow noreferrer"
            className="bg-[#E10600] hover:bg-red-700 text-white font-bold text-sm px-4 py-2 md:px-6 md:py-2.5 rounded-md transition-all duration-200 whitespace-nowrap flex items-center gap-2 cursor-pointer"
          >
            <i className="ri-whatsapp-line text-base"></i>
            <span className="hidden sm:inline">Cotizar</span>
          </a>
        </div>
      </nav>

      {/* Hero */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        {/* Background */}
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/0ff86773000541e144cc6a36b257dcbd.png"
            alt="Mitsubishi L200 - Repuestos Octavio Ospina"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/30"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-black/20"></div>
        </div>

        {/* Red accent line */}
        <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#E10600]"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-24 pb-16 w-full">
          <div className="max-w-2xl">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 border border-[#E10600] bg-black/40 backdrop-blur-sm text-white text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-6 animate-fade-in">
              <span className="w-2 h-2 bg-[#E10600] rounded-full"></span>
              40+ años de experiencia
            </div>

            {/* Title */}
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-4">
              Repuestos Originales<br />
              <span className="text-[#E10600]">Mitsubishi</span><br />
              en Colombia
            </h1>

            {/* Subtitle */}
            <p className="text-lg md:text-2xl text-white/90 font-semibold mb-3">
              Más de 40 años brindando respaldo, calidad y asesoría especializada
            </p>

            {/* Description */}
            <p className="text-base md:text-lg text-white/75 mb-10 max-w-xl">
              Encuentra el repuesto exacto para tu vehículo con expertos. Atención personalizada y envíos a todo Colombia.
            </p>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={WA_LINK_1}
                target="_blank"
                rel="nofollow noreferrer"
                className="bg-[#E10600] hover:bg-red-700 text-white font-black text-base md:text-lg px-8 py-4 rounded-lg transition-all duration-200 hover:scale-105 flex items-center justify-center gap-3 shadow-lg shadow-red-900/40 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                Cotizar por WhatsApp
              </a>
              <a
                href="https://wa.link/szf6pp"
                target="_blank"
                rel="nofollow noreferrer"
                className="border-2 border-white text-white hover:bg-white hover:text-black font-bold text-base md:text-lg px-8 py-4 rounded-lg transition-all duration-200 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-search-line text-xl"></i>
                Averigua tu repuesto
              </a>
            </div>

            {/* Stats */}
            <div className="flex flex-wrap gap-8 mt-12 pt-8 border-t border-white/20">
              {[
                { value: "40+", label: "Años de experiencia" },
                { value: "100%", label: "Repuestos originales y Homologados" },
                { value: "Envios", label: "A toda Colombia." },
              ].map((stat) => (
                <div key={stat.label}>
                  <div className="text-2xl md:text-3xl font-black text-[#E10600]">{stat.value}</div>
                  <div className="text-white/70 text-sm">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/50 text-xs uppercase tracking-widest">Desliza</span>
          <i className="ri-arrow-down-line text-white/50 text-xl"></i>
        </div>
      </section>
    </>
  );
}
